module.exports = __webpack_public_path__ + "static/Code-audit-UX-audit-banner-image-00a0c8f0259c276b25ec82cbf4255d48.png";